<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '../../stores/auth'
import AuthModal from '../auth/AuthModal.vue'
import NotificationButton from '../ui/notification/NotificationButton.vue'
import ReportButton from '../../components//reports//ReportButton.vue'
import SearchBox from '../ui/search/SearchBox.vue'
import UserMenu from './navigation/UserMenu.vue'
import Logo from '../ui/Logo.vue'
import { useScreenSize } from '../../utils/useScreenSize'
import { tokenManager } from '../../api/utils/tokenManager'

const { isMobile } = useScreenSize();

const { isAuthenticated } = storeToRefs(useAuthStore())
const showAuthModal = ref(false)

defineEmits<{
  (e: 'toggleMobileMenu'): void
}>()

</script>

<template>
  <header class="bg-white dark:bg-black border-b border-gray-100 dark:border-gray-800 fixed top-0 left-0 right-0 z-50">
    <div class="mx-auto px-4 py-4 flex items-center justify-between">
      <div class="flex items-center space-x-1">
        <!--<MobileMenuButton 
          :is-open="false" 
          @toggle="$emit('toggleMobileMenu')" 
        />-->
        <Logo />
        <span class="text-info" v-if="!isMobile"> - {{ tokenManager.getCompany()?.company_name }}</span>
        <!--<MegaMenu class="hidden md:block" />-->
      </div>

      <!-- Search Box -->
      <div class="hidden md:flex-1 max-w-3xl mx-8">
        <SearchBox v-if="isAuthenticated" />
      </div>

      <div class="flex items-center space-x-4">
        <NotificationButton v-if="isAuthenticated" />
        <ReportButton v-if="isAuthenticated" />
        <!--<ThemeToggle />-->
        
        <!-- Show UserMenu when authenticated, otherwise show auth buttons -->
        <template v-if="isAuthenticated">
          <UserMenu />
        </template>
        <template v-else>
          <button 
            @click="showAuthModal = true"
            class="hidden sm:block px-4 py-2 text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
          >
            Sign In
          </button>
          <button class="hidden sm:block px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors">
            Get Started
          </button>
        </template>
      </div>
    </div>

    <!-- Auth Modal -->
    <AuthModal 
      v-if="showAuthModal"
      @close="showAuthModal = false"
    />
  </header>
</template>
<style scoped>
/* Optionally you can add custom styles for smooth transition */
header {
  transition: top 0.3s ease;
}
</style>